import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/priceCalculator';

const CSS = `
.ast-pd2-overlay{position:fixed;inset:0;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:16px;z-index:100000;}
.ast-pd2{background:#fff;border-radius:12px;width:min(940px,96vw);height:min(640px,92vh);display:flex;flex-direction:column;position:relative;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.35);}
.ast-pd2-close{position:absolute;top:10px;right:12px;border:none;background:transparent;font-size:28px;line-height:1;cursor:pointer;color:#666;z-index:3;}
.ast-pd2-body{flex:1;min-height:0;display:flex;gap:24px;padding:24px;overflow:hidden;}
.ast-pd2-media{flex:0 0 340px;max-width:340px;display:flex;flex-direction:column;gap:10px;}
.ast-pd2-main{width:340px;height:340px;border:1px solid #e5e5e5;border-radius:10px;background:#f7f7f8;display:flex;align-items:center;justify-content:center;overflow:hidden;}
.ast-pd2-main img{max-width:100%;max-height:100%;object-fit:contain;display:block;}
.ast-pd2-main .dashicons{font-size:64px;width:64px;height:64px;color:#c7c7c7;}
.ast-pd2-thumbs{display:flex;gap:8px;flex-wrap:wrap;}
.ast-pd2-thumb{padding:0;border:1px solid #e5e5e5;border-radius:6px;background:none;cursor:pointer;line-height:0;}
.ast-pd2-thumb.is-active{border-color:#b32d2e;box-shadow:0 0 0 1px #b32d2e;}
.ast-pd2-thumb img{width:56px;height:56px;object-fit:cover;border-radius:5px;}
.ast-pd2-info{flex:1;min-width:0;overflow-y:auto;padding-right:8px;}
.ast-pd2-sku{display:inline-block;font-size:12px;letter-spacing:.03em;color:#888;margin-bottom:4px;}
.ast-pd2-name{margin:0 0 10px;font-size:22px;line-height:1.25;color:#111;}
.ast-pd2-desc{white-space:pre-wrap;color:#374151;line-height:1.55;margin:0 0 12px;}
.ast-pd2-meta{margin-top:12px;font-size:14px;color:#4b5563;}
.ast-pd2-meta b{color:#111;}
.ast-pd2-footer{border-top:1px solid #eee;padding:14px 24px;display:flex;align-items:center;gap:16px;flex-wrap:wrap;background:#fff;}
.ast-pd2-price{font-size:22px;font-weight:700;color:#111;}
.ast-pd2-price small{display:block;font-size:12px;font-weight:400;color:#6b7280;}
.ast-pd2-spacer{flex:1;}
.ast-pd2-check{display:flex;align-items:center;gap:6px;font-size:14px;cursor:pointer;color:#374151;}
@media (max-width:680px){
  .ast-pd2{height:92vh;}
  .ast-pd2-body{flex-direction:column;overflow-y:auto;}
  .ast-pd2-media{flex:none;max-width:none;align-items:center;}
  .ast-pd2-main{width:100%;max-width:320px;height:260px;}
  .ast-pd2-info{overflow:visible;}
}
`;

export default function ProductDetail({ product, showPrices, selected, onToggleSelect, onClose, onQuoteRequest }) {
    const { t } = useTranslation();
    const gallery = [product?.image_url, product?.image_url_2, product?.image_url_3].filter(Boolean);
    const [activeImg, setActiveImg] = useState(gallery[0] || '');

    if (!product) return null;

    const showPrice = showPrices && product.price_type !== 'included' && product.price_type !== 'none';

    return (
        <div className="ast-pd2-overlay" onClick={onClose}>
            <style>{CSS}</style>
            <div className="ast-pd2" onClick={(e) => e.stopPropagation()}>
                <button className="ast-pd2-close" onClick={onClose} aria-label="Sluiten">&times;</button>

                <div className="ast-pd2-body">
                    <div className="ast-pd2-media">
                        <div className="ast-pd2-main">
                            {activeImg
                                ? <img src={activeImg} alt={product.name} />
                                : <span className="dashicons dashicons-cart"></span>}
                        </div>
                        {gallery.length > 1 && (
                            <div className="ast-pd2-thumbs">
                                {gallery.map((url) => (
                                    <button
                                        key={url}
                                        type="button"
                                        className={`ast-pd2-thumb ${url === activeImg ? 'is-active' : ''}`}
                                        onClick={() => setActiveImg(url)}
                                    >
                                        <img src={url} alt="" />
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="ast-pd2-info">
                        {product.sku && <span className="ast-pd2-sku">{product.sku}</span>}
                        <h2 className="ast-pd2-name">{product.name}</h2>
                        {product.description && <p className="ast-pd2-desc">{product.description}</p>}
                        {product.product_category_name && (
                            <div className="ast-pd2-meta">
                                <b>Categorie:</b> {product.product_category_name}
                            </div>
                        )}
                    </div>
                </div>

                <div className="ast-pd2-footer">
                    {showPrice && (
                        <div className="ast-pd2-price">
                            {product.price_type === 'on_request'
                                ? <span className="ast-price-on-request">Op nacalculatie</span>
                                : <>{formatPrice(product.price)}<small>Prijs is indicatief</small></>}
                        </div>
                    )}
                    <div className="ast-pd2-spacer" />
                    {onToggleSelect && (
                        <label className="ast-pd2-check">
                            <input
                                type="checkbox"
                                checked={!!selected}
                                onChange={() => onToggleSelect(product)}
                            />
                            Toevoegen aan offerteaanvraag
                        </label>
                    )}
                    <button className="ast-btn ast-btn--primary" onClick={() => onQuoteRequest(product)}>
                        {t('catalog.requestQuote')}
                    </button>
                </div>
            </div>
        </div>
    );
}
